module.exports = __webpack_public_path__ + "static/c3f9b852-6856-439c-8477-566f9ca6acfb-160.f3fbcc48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/banjoVase-cinnamon/c3f9b852-6856-439c-8477-566f9ca6acfb-160.jpg
// module id = 882
// module chunks = 168707334958949